var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78858 0.206586C9.44338 -0.0363094 8.98285 -0.03631 8.63765 0.206585L0.641272 5.8332C-0.157305 6.39512 0.240277 7.65103 1.21674 7.65103H1.96681V15.3636C1.96681 16.1015 2.69132 16.7053 3.57684 16.7053H6.79692V12.4227C6.79692 11.8704 7.24464 11.4227 7.79692 11.4227H10.627C11.1793 11.4227 11.627 11.8704 11.627 12.4227V16.7053H14.847C15.7325 16.7053 16.4571 16.1015 16.4571 15.3636V7.65103H17.2095C18.186 7.65103 18.5835 6.39512 17.785 5.83321L9.78858 0.206586Z",
    fill: "#FDFDFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWhite);
export default __webpack_public_path__ + "static/media/home_white.d154c3908435cfb53025d2593c7d9675.svg";
export { ForwardRef as ReactComponent };